export interface  DatosCompraType {
  type: string;
  label: string;
  inputType: string;
  name: string;
  required: boolean;
  visible: boolean;
}

export interface  DatosPublicidadType {
  type: string;
  label: string;
  inputType: string;
  name: string;
  options?: string[];
  required: boolean;
  visible: boolean;
}

export interface caracteristicasAdicionalesType {
  LetraLocalizador?: string;
  ValidarHoraVisita?: string;
  DobleLayoutEntradas?: string;
  ValidarRN?: string;
  CompraPases?: string;
  CompraDesdeAdmin?: string;
  VerProductosRelacionados?: string;
  MostrarAforoDisponible?: string;
  CodigoClienteAsociado?: string;
  DatosCompra?: DatosCompraType[];
  DatosPublicidad?: DatosPublicidadType[];   
}

export enum DatosFacturaInputNameTypesEnum {
  UTILIZAR_DATOS_CLIENTE = 'UtilizarDatosCliente',
  NOMBRE = 'nombrefactura',
  TIPO_DOCUMENTO = 'tipoDocumento',
  DOCUMENTO = 'documento',
  DIRECCION = 'direccion',
  PAIS = 'pais',
  PROVINCIA = 'provincia',
  LOCALIDAD = 'localidad',
  CODIGO_POSTAL = 'codigoPostal',
  IS_PANEL_VISIBLE = 'isPanelVisible',
  CIUDAD = 'ciudad'
}

export enum TyposDeInputEnam {
  TEXT = 'text',
  NUMBER = 'number',
  SELECT = 'select',
  INPUT = 'input',
  CHECKBOX = 'checkbox',
  EMAIL = 'email',
  DATE = 'date',
  BUTTON = 'button',
  SUBMIT = 'submit',
  RANGE = 'range'
}

export interface FacturaFormDataValue {
  UtilizarDatosCliente?: boolean;
  nombrefactura: string;
  tipoDocumento: string;
  documento: string;
  direccion: string;
  pais: string;
  provincia: string;
  localidad: string;
  codigoPostal: string;
  nombrePais?: string;
  isPanelVisible?: boolean;
  iSolicitaFactura?: number;
  generateFacturaType?: number;
}

export interface PaisesResponse {
  DatosPaises: DatosPaises[]
}

export interface DatosPaises {
  CodPais: string;
  NombrePais: string;
  CountryCode: string;
  idPais: string;
  Seleccionable: string;
  OrdenVisualizacion: string;
}

export interface CiudadesResponse {
  DatosResult: DatosCiudadesResult
  Mensajes: any[]
  LoginDatos: any
}

export interface DatosCiudadesResult {
  DatosCiudades: DatosCiudades[]
}

export interface DatosCiudades {
  idCiudad: any;
  CodCiudad: string;
  NombreCiudad: string;
  idProvincia: any;
  CodProvincia: string;
  NombreProvincia: string;
  idComunidad: string;
  codComunidad: string;
  idPais: string;
  Seleccionable: string;
  OrdenVisualizacion: string;
  NombreComunidad: any;
}

export interface ClientFormItems {
  items: ClientFormDataValue
}
export interface ClientFormDataValue {
  Nombrecentro?: string;
  Nombrecontacto?: string;
  nombre: string;
  apellidos: string;
  email: string;
  emailconfirmacion: string;
  tipoDocumento: string;
  documento: string;
  direccion: string;
  codigoPostal: string;
  localidad: string;
  ciudad: string;
  provincia: string;
  pais: string;
  telefono: string;
  publicidad: string;
  privacidad: string;
  pago: string;
  codigoPais: string;
}

export enum DatosCompraInputNamesEnum {
  NOMBRE_CENTRO = 'Nombrecentro',
  NOMBRE_CONTACTO = 'Nombrecontacto',
  NOMBRE = 'nombre',
  APELLIDOS = 'apellidos',
  EMAIL = 'email',
  CODIG_POSTAL = 'codigoPostal',
  TIPO_DOCUMENTO = 'tipoDocumento',
  DOCUMENTO = 'documento',
  CIF_O_DNI = 'CIFoDNI',
  PAIS = 'pais',
  PROVINCIA = 'provincia',
  DIRECCION = 'direccion',
  CIUDAD = 'ciudad',
  LOCALIDAD = 'localidad',
  CODIGO_PAIS = 'codigoPais',
}
